export default function reducer(state, action) {
  switch (action.type) {
    case "SET_CLIENT_TOKEN":
      return {
        ...state,
        clientToken: action.payload
      };
    case "SET_STATUS":
      return {
        ...state,
        status: action.payload
      };
    case "SET_ERROR":
      return {
        ...state,
        error: action.payload
      };
    case "SET_PAYPAL_DATA":
      return {
        ...state,
        paypalData: action.payload
      };
    case "DISABLE_PAYPAL":
      return {
        ...state,
        status: action.payload
      };
    default:
      return state;
  }
}
